// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__OuSZB","msg":"Message_msg__zEKrE","msgVideo":"Message_msgVideo__2D2Vb"};